// extracted by mini-css-extract-plugin
export default {"skeletBlock":"CarouselSkelet_skeletBlock--WT8","skeletShimmer":"CarouselSkelet_skeletShimmer--PsJ"};